import { GenIcon } from '../helpers/IconBase.es.js';

const HeartOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_16385_706)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M11.6666 1.27768C10.9159 1.28936 10.1816 1.49891 9.53777 1.88519C8.89398 2.27147 8.36351 2.82079 7.99993 3.47768C7.63636 2.82079 7.10589 2.27147 6.46209 1.88519C5.81829 1.49891 5.08396 1.28936 4.33327 1.27768C3.13656 1.32967 2.00907 1.85318 1.19712 2.73383C0.385171 3.61449 -0.0452355 4.7807 -6.84962e-05 5.97768C-6.84962e-05 9.00901 3.1906 12.3197 5.8666 14.5643C6.46408 15.0664 7.2195 15.3417 7.99993 15.3417C8.78036 15.3417 9.53579 15.0664 10.1333 14.5643C12.8093 12.3197 15.9999 9.00901 15.9999 5.97768C16.0451 4.7807 15.6147 3.61449 14.8027 2.73383C13.9908 1.85318 12.8633 1.32967 11.6666 1.27768ZM9.2766 13.5443C8.91925 13.8453 8.4671 14.0103 7.99993 14.0103C7.53276 14.0103 7.08061 13.8453 6.72326 13.5443C3.29793 10.6703 1.33326 7.91301 1.33326 5.97768C1.28769 5.13416 1.57751 4.30683 2.13951 3.67615C2.70151 3.04546 3.49009 2.66258 4.33327 2.61101C5.17644 2.66258 5.96502 3.04546 6.52702 3.67615C7.08902 4.30683 7.37884 5.13416 7.33326 5.97768C7.33326 6.15449 7.4035 6.32406 7.52853 6.44908C7.65355 6.57411 7.82312 6.64435 7.99993 6.64435C8.17674 6.64435 8.34631 6.57411 8.47134 6.44908C8.59636 6.32406 8.6666 6.15449 8.6666 5.97768C8.62103 5.13416 8.91084 4.30683 9.47284 3.67615C10.0348 3.04546 10.8234 2.66258 11.6666 2.61101C12.5098 2.66258 13.2984 3.04546 13.8604 3.67615C14.4224 4.30683 14.7122 5.13416 14.6666 5.97768C14.6666 7.91301 12.7019 10.6703 9.2766 13.5417V13.5443Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_16385_706" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { HeartOutlined };
